<template>
	<div>
		<!-- AI Data Popup Component -->
		<AIDataPopup ref="aiDataPopup" :selectedFile="selectedFile" />

		<v-toolbar>
			<!-- <v-toolbar-title>{{selectedFile.filename}}</v-toolbar-title> -->
			<v-autocomplete
				v-model="selectedStockist"
				item-value="stockist_code"
				flat
				placeholder="Search Stockist"
				:items="stockistList"
				:allow-overflow="false"
				:item-text="getItemText"
				:filter="customFilter"
			></v-autocomplete>
			<v-autocomplete
				v-model="selectedReasons"
				:items="rejectReasons"
				:allow-overflow="false"
				multiple
				flat
				placeholder="Reject with Reason"
				style="margin-left: 10px"
			></v-autocomplete>
			<v-spacer></v-spacer>
			<v-tooltip bottom v-if="showPredictedStockistData">
				<template v-slot:activator="{ on }">
					<v-btn
						outline
						flat
						color="purple darken-1"
						@click="generateAIStockist"
						v-on="on"
						>Generate AI Stockist</v-btn
					>
				</template>
				<span>Generate AI Predicted Stockist Data.</span>
			</v-tooltip>
			<v-tooltip bottom>
				<template v-slot:activator="{ on }">
					<v-btn
						outline
						flat
						color="blue darken-1"
						@click="formatConfig"
						v-on="on"
						>Format</v-btn
					>
				</template>
				<span>Format Meta.</span>
			</v-tooltip>
			<v-tooltip bottom>
				<template v-slot:activator="{ on }">
					<v-btn
						:disabled="disableVerify"
						outline
						flat
						color="green darken-1"
						@click="verify"
						v-on="on"
						>Verify</v-btn
					>
				</template>
				<span>Verify Current Meta.</span>
			</v-tooltip>
			<v-tooltip bottom>
				<template v-slot:activator="{ on }">
					<v-btn
						:disabled="disableExtractAndSave"
						outline
						flat
						color="pink darken-1"
						@click="extactAndSave"
						v-on="on"
						>Map file</v-btn
					>
				</template>
				<span>Map File</span>
			</v-tooltip>
			<v-tooltip bottom>
				<template v-slot:activator="{ on }">
					<v-btn
						outline
						flat
						color="yellow darken-2"
						@click="forceMapFile"
						v-on="on"
						>FM</v-btn
					>
				</template>
				<span>FORCE MAP file.</span>
			</v-tooltip>
			<v-tooltip bottom>
				<template v-slot:activator="{ on }">
					<v-btn outline flat color="red darken-1" @click="hideFile" v-on="on"
						>Hide</v-btn
					>
				</template>
				<span>Hide file from Mapping Screen</span>
			</v-tooltip>
		</v-toolbar>
		<div style="overflow:scroll;">
			<brace
				style="height:90vh;"
				class="kbet-editor"
				:mode="'json'"
				@code-change="onEditorCodeChange"
				@setHandler="
					h => {
						editorHandler = h;
					}
				"
			/>
		</div>
	</div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import AIDataPopup from './AIDataPopup.vue'; // Adjust the path as needed

export default {
	components: {
		AIDataPopup,
	},
	created() {
		this.selectedStockist = '';
	},
	data() {
		return {
			editorHandler: false,
			disableVerify: true,
			disableExtractAndSave: true,
			selectedStockist: '',
			selectedStockistObj: {},
			nonEditableHeaders: [
				'_id',
				'stockist_code',
				// "email",
				'gst_no',
				'line_1',
				'line_2',
				'city',
				'state',
				'name',
				'valid',
				'_do_not_extract',
				'_valid_email',
			],
			selectedReasons: [],
			rejectReasons: [...require('../../components/rejects.json')],
		};
	},
	methods: {
		...mapActions('identifyStockist', [
			'verifyMeta',
			'extractAndSaveMeta',
			'registerHeaderMapping',
			'hideFileForMapping',
			// "unlockFile",
			'forceMapStockist',
		]),
		...mapActions('fileExtraction', [
			'unlockFile',
			'forceRejectFilesFromBackend',
		]),
		...mapMutations(['openSnackbar', 'openLoaderDialog', 'closeLoaderDialog']),
		...mapMutations('identifyStockist', [
			'refreshStockistListEmitter',
			'closeFileMetaDialog',
		]),
		generateAIStockist() {
			console.log('DEBUG: generateAIStockist method called');
			console.log('DEBUG: selectedFile =', this.selectedFile);
			console.log('DEBUG: $refs =', this.$refs);
			console.log('DEBUG: aiDataPopup ref =', this.$refs.aiDataPopup);
		
			// Set the AI predicted stockist ID in the search field
			// This will automatically trigger the watcher which updates the editor panel
			if (this.selectedFile && this.selectedFile.AI_predicted_stockist_id) {
				this.selectedStockist = this.selectedFile.AI_predicted_stockist_id.trim();
			
				// Show success message
				this.openSnackbar({
					text: 'AI Stockist data loaded successfully',
				});
			} else {
				// Show warning if no AI predicted stockist data is available
				this.openSnackbar({
					text: 'No AI predicted stockist data available for this file',
				});
			}
		
			// Also show the AI data popup for additional information
			// Use $nextTick to ensure the component reference is available
			this.$nextTick(() => {
				console.log('DEBUG: Inside $nextTick, aiDataPopup ref =', this.$refs.aiDataPopup);
				if (this.$refs.aiDataPopup) {
					console.log('DEBUG: Setting showPopup = true');
					this.$refs.aiDataPopup.showPopup = true;
				} else {
					console.log('DEBUG: aiDataPopup ref not available, trying with setTimeout');
					// If reference is still not available, try again after a short delay
					setTimeout(() => {
						console.log('DEBUG: Inside setTimeout, aiDataPopup ref =', this.$refs.aiDataPopup);
						if (this.$refs.aiDataPopup) {
							console.log('DEBUG: Setting showPopup = true (delayed)');
							this.$refs.aiDataPopup.showPopup = true;
						} else {
							console.log('DEBUG: aiDataPopup ref still not available after delay');
						}
					}, 200);
				}
			});
		},
		onEditorCodeChange(code) {
			this.editorCode = code;
			// this.disableVerify = true;
			this.disableExtractAndSave = true;
		},
		customFilter(item, queryText, itemText) {
			if (item.stockist_code.indexOf(queryText) > -1) {
				return true;
			} else {
				let name = item.name;
				let city = item.city;
				let newQueryText = queryText.toLowerCase().replace(/[^A-Z0-9]/gi, '');

				name = name.toLowerCase().replace(/[^A-Z0-9]/gi, '');
				city = city.toLowerCase().replace(/[^A-Z0-9]/gi, '');
				return (
					name.indexOf(newQueryText) > -1 || city.indexOf(newQueryText) > -1
				);
			}
		},
		formatConfig() {
			if (
				this.jsonValidate(this.editorCode) &&
				this.validateCustomElements(this.editorCode)
			) {
				let selectedStockistMeta = JSON.parse(this.editorCode);
				this.editorHandler.setValue(
					JSON.stringify(this.resetHeaderValue(selectedStockistMeta), null, 2)
				);
			} else {
				this.openSnackbar({
					text:
						'Invalid JSON please check json, selected stockist or Custom elements',
				});
			}
		},
		verify() {
			if (
				this.jsonValidate(this.editorCode) &&
				this.validateCustomElements(this.editorCode)
			) {
				let conf = this.resetHeaderValue(JSON.parse(this.editorCode));
				this.openLoaderDialog();
				this.verifyMeta({
					stockistMeta: conf,
					// filters: [{ uuid: this.selectedFile.uuid }],
					sender: this.selectedFile.sender,
					...this.getSelectedDates,
				}).then(data => {
					this.closeLoaderDialog();
					if (data) {
						this.disableExtractAndSave = false;
						this.openSnackbar({ text: 'Matched Files check log' });
					} else {
						this.openSnackbar({
							text: 'Did not match any file check logs',
						});
					}
				});
			} else {
				this.openSnackbar({
					text:
						'Invalid JSON please check json, selected stockist or Custom elements',
				});
			}
		},
		async forceMapFile() {
			if (window.confirm('Are you sure you want to FORCE MAP this FILE')) {
				if (
					this.jsonValidate(this.editorCode) &&
					this.validateCustomElements(this.editorCode) &&
					this.selectedStockist != ''
				) {
					let conf = this.resetHeaderValue(JSON.parse(this.editorCode));
					this.openLoaderDialog();
					this.forceMapStockist({
						stockistMeta: conf,
						uuids: [
							this.selectedFile.originalFileUUID || this.selectedFile.uuid,
						],
						// sender: this.selectedFile.sender,
						...this.getSelectedDates,
					}).then(data => {
						this.closeLoaderDialog();
						if (data) {
							this.openSnackbar({
								text: 'Force mapped file successfully',
							});
							this.refreshStockistListEmitter();
							this.closeDialog();
						} else {
							this.openSnackbar({
								text: 'Failed to force map file',
							});
						}
					});
				} else {
					this.openSnackbar({
						text:
							'Invalid JSON please check json, selected stockist or Custom elements',
					});
				}
			}
		},
		async extactAndSave() {
			if (window.confirm('Are you sure you want to extract this file??????')) {
				if (
					this.jsonValidate(this.editorCode) &&
					this.validateCustomElements(this.editorCode)
				) {
					let conf = this.resetHeaderValue(JSON.parse(this.editorCode));
					this.openLoaderDialog();
					this.extractAndSaveMeta({
						stockistMeta: conf,
						// filters: [{ uuid: this.selectedFile.uuid }],
						sender: this.selectedFile.sender,
						...this.getSelectedDates,
					}).then(data => {
						this.closeLoaderDialog();
						if (data) {
							this.openSnackbar({
								text: 'Mapped and Saved file and meta details',
							});
							this.refreshStockistListEmitter();
							this.closeDialog();
						} else {
							this.openSnackbar({
								text: 'Failed to Map file and meta details check logs',
							});
						}
					});
				} else {
					this.openSnackbar({ text: 'Invalid JSON please check' });
				}
			}
		},
		async hideFile() {
			if (window.confirm('Are you sure you want to hide this file ???')) {
				this.openLoaderDialog();

				if (this.selectedReasons.length) {
					let filesToDelete = [this.selectedFile.uuid];
					let additionalRemark = this.selectedReasons.join(', ');

					const data = await this.forceRejectFilesFromBackend({
						uuids: filesToDelete,
						additionalRemark,
					});

					if (!data) {
						this.openSnackbar({
							text: 'Failed to force reject the file',
						});
						this.closeLoaderDialog();
						return;
					}
				}

				this.hideFileForMapping({
					uuids: [this.selectedFile.uuid],
				}).then(data => {
					this.closeLoaderDialog();
					if (data) {
						this.refreshStockistListEmitter();
						this.closeDialog();
					} else {
						this.openSnackbar({
							text: 'Failed to hide file please try again.',
						});
					}
				});
			}
		},
		jsonValidate(json) {
			try {
				JSON.parse(json);
				return true;
			} catch (err) {
				return false;
			}
		},
		validateCustomElements(json) {
			let conf = JSON.parse(json);
			for (let ele of conf.custom) {
				if (!Array.isArray(ele)) {
					return false;
				} else {
					if (ele.length == 0) {
						return false;
					} else {
						for (let item of ele) {
							if (typeof item != 'string' || item == '') {
								return false;
							}
						}
					}
				}
			}
			return true;
		},
		closeDialog() {
			// _id: "5cde85113e4a6e0b2701d6cc"
			this.unlockFile(this.selectedFile._id).then(data => {
				if (!data) {
					this.closeFileMetaDialog();
				}
			});
		},
		initialiseEditor() {
			let initialMetaConfig = JSON.parse(`{
				"_id": "",
				"stockist_code": "",
				"email": "",
				"gst_no": "",
				"line_1": "",
				"line_2": "",
				"city": "",
				"state": "",
				"name": "",
				"valid": 0,
				"_do_not_extract": false,
				"_valid_email": false,
				"custom": []																																																																						}`);
			this.editorHandler.setValue(JSON.stringify(initialMetaConfig, null, 2));
		},
		resetHeaderValue(conf) {
			for (let header of this.nonEditableHeaders) {
				conf[header] = this.selectedStockistObj[header];
			}
			return conf;
		},
		getItemText(item) {
			return `${item.stockist_code} - ${item.name} - ${item.city}`;
		},
	},
	computed: {
		...mapGetters(['getSelectedDates', 'userData']),
		...mapGetters('identifyStockist', ['selectedFile', 'stockistList']),
		showPredictedStockistData() {
			return (
				this.selectedFile &&
				this.selectedFile.AI_predicted_stockist_id &&
				this.selectedFile.AI_predicted_stockist_id.trim() !== ''
			);
		},
	},
	watch: {
		selectedStockist(nv) {
			this.selectedStockistObj = this.stockistList.find(
				e => e.stockist_code == nv
			);
			this.editorHandler.setValue(
				JSON.stringify(this.selectedStockistObj, null, 2)
			);
			this.disableVerify = false;
		},
	},
	mounted() {
		this.initialiseEditor();
		console.log(this.selectedFile, 'test');
		if (
			this.selectedFile &&
			this.selectedFile.AI_predicted_stockist_id &&
			this.selectedFile.AI_predicted_stockist_id.trim() !== ''
		) {
			// this.generateAIStockist();
			this.selectedStockist = this.selectedFile.AI_predicted_stockist_id;
		}
		// Listen for auto-trigger Generate AI Stockist mutation
		this.$store.subscribe(mutation => {
			console.log('DEBUG: Mutation received:', mutation.type, mutation.payload);
			if (mutation.type === 'identifyStockist/triggerGenerateAIStockist' && mutation.payload) {
				console.log('DEBUG: Triggering Generate AI Stockist after delay');
				// Small delay to ensure component is fully mounted
				setTimeout(() => {
					console.log('DEBUG: Calling generateAIStockist method');
					this.generateAIStockist();
				}, 100);
			}
		});
	},
};
</script>

<style lang="scss" scoped></style>
